<template>
<!-- Schedule Section -->
<!-- Schedule Section -->
<section id="schedule" class="schedule py-5 bg-light">
  <div class="container">
    <h2 class="mb-2 text-uppercase fw-bold text-center text-primary">
      {{ $t('schedule.title') }}
    </h2>
<h4 class="text-center fw-bold animate__animated animate__fadeIn mb-2" :class="isScheduleBdin ? 'text-success' : 'text-success'">
  {{
    $i18n.locale === 'ro'
      ? (isScheduleBdin ? 'Feribotul BDIN trece azi' : 'Feribotul EUROPA trece azi')
      : $i18n.locale === 'bg'
      ? (isScheduleBdin ? 'Ферибот BDIN преминава днес' : 'Ферибот EUROPA преминава днес')
      : (isScheduleBdin ? 'Ferry BDIN is operating today' : 'Ferry EUROPA is operating today')
  }}
</h4>

    <p class="text-center text-muted">
      {{ $t("schedule.description") }}
    </p>

    <!-- Europa Schedule -->
<div class="row justify-content-center mt-4">
  <h5 class="text-uppercase text-center fw-bold text-primary mb-4">
    {{ $t('schedule.europa') }}
  </h5>

  <div class="col-md-6 col-lg-3 mb-4" v-for="(item, index) in staticSchedule" :key="index">
    <div class="card shadow-sm border-0 text-center h-100 animate__animated animate__fadeInUp">
      <div class="card-body py-4">
        <div class="mb-3">
          <i class="fas fa-clock fa-2x text-primary"></i>
        </div>
        <h6 class="fw-bold text-muted text-uppercase text-primary">
          {{ $t('schedule.departure.from') }} 
        </h6>
        <p class="mb-1 d-flex align-items-center justify-content-center">
          <i class="fa fa-clock-o text-success me-2"></i>
          <span>{{ item.start }}</span>
        </p>
        </div>
    </div>
  </div>
</div>
  </div>
</section>
<section class="traffic py-5 bg-white border-top">
  <div class="container">
    <h2 class="mb-3 text-uppercase fw-bold text-center text-primary">
      {{ $t("traffic.title") }}
    </h2>
    <p class="text-center text-muted mb-4">
      {{ $t("traffic.description") }}
    </p>

    <HlsTrafficPlayer />
  </div>
</section>


<section class="products py-5 bg-white">
    <div class="container">
      <h2 class="mb-4 text-uppercase fw-bold text-center text-primary">
        {{ $t("products.title") }}
      </h2>
    <!-- Descriere Produse -->
    <p class="text-center text-muted">
      {{ $t("products.description") }}
    </p>
      <!-- Mesaj dacÄƒ nu existÄƒ produse -->
      <p v-if="products.length === 0" class="text-center text-danger">
        ðŸš¨ {{ $t("products.noProducts") }}
      </p>

      <!-- AfiÈ™are Produse -->
<!-- Afișare Produse în 2 rânduri -->
<div v-if="products.length > 0">
  <div class="row justify-content-center mb-4" v-for="(group, i) in productChunks" :key="i">
    <div class="col-6 col-md-4 col-lg-2 mb-3" v-for="product in group" :key="product.id">
      <div class="card product-card shadow-sm h-100 text-center">
        <img
          :src="getProductImage(product.image_url)"
          :alt="getProductName(product.name)"
          class="card-img-top"
        />
        <div class="card-body">
          <h5 class="card-title fw-bold">{{ getProductName(product.name) }}</h5>
          <p class="card-text price">
            {{ formatPrice(product.price_tva_included) }} {{ product.currency }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>




      <!-- Buton pentru /bilete -->
      <div class="text-center mt-4">
        <router-link to="/bilete" class="btn btn-primary btn-lg shadow">
          {{ $t("products.buyTickets") }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import HlsTrafficPlayer from "@/components/HlsTrafficPlayer.vue";

export default {
  name: "ProductList",  components: {
    HlsTrafficPlayer,
  },
data() {
  return {
    products: [],
staticSchedule: [
  { start: "07:30", end: "07:40" },
  { start: "12:00", end: "12:10" },
  { start: "16:00", end: "16:10" },
  { start: "19:00", end: "19:10" }
],

    isScheduleBdin: false,  // <-- true = BDIN, false = EUROPA
  };
},
mounted() {
  this.loadProducts();
  this.loadScheduleStatus();
},computed: {
  productChunks() {
    const chunkSize = 6;
    const chunks = [];
    for (let i = 0; i < this.products.length; i += chunkSize) {
      chunks.push(this.products.slice(i, i + chunkSize));
    }
    return chunks;
  }
},

methods: {
  loadProducts() {
    axios
      .get("https://api.feribot-eurobac.ro/client/api/products")
      .then((response) => {
        this.products = response.data;
      })
      .catch((error) => {
        console.error("Error loading products:", error);
      });
  },
  loadScheduleStatus() {
    axios
      .get("https://api.feribot-eurobac.ro/client/api/schedule-status")
      .then((response) => {
        this.isScheduleBdin = response.data.schedule === true;
      })
      .catch((error) => {
        console.error("Error loading schedule status:", error);
      });
  },
  getProductImage(imageUrl) {
    return imageUrl ? `https://api.feribot-eurobac.ro${imageUrl}` : "/default-image.png";
  },
  getProductName(name) {
    const translatedName = this.$t(`products.${name}`);
    return translatedName !== `products.${name}` ? translatedName : name; 
  },
  formatPrice(value) {
    if (!value) return '0.00';
    return Number(value).toFixed(2);
  }
}

};
</script>
<style scoped>
/* Stilizare Produse */
.product-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  text-align: center;
  height: 100%;
  padding: 15px;
}

.product-card:hover {
  transform: scale(1.05);
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.15);
}

/* Imagine produs */
.product-card img {
  background: #338af3;
  padding: 10px;
  border-radius: 12px 12px 0 0;
  height: 120px;
  object-fit: contain;
}

/* Titlu produs */
.card-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
  margin-top: 10px;
}

/* PreÈ› */
.price {
  font-size: 1.1rem;
  font-weight: bold;
  color: #ff6f00;
  margin-bottom: 10px;
}

/* Buton */
.btn-primary {
  background-color: #0056b3;
  border: none;
  transition: background 0.3s ease-in-out;
}

.btn-primary:hover {
  background-color: #002e70;
}

.schedule-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.schedule-card:hover {
  transform: scale(1.02);
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.15);
}

.table {
  margin-bottom: 0;
  border-radius: 8px;
  overflow: hidden;
}

.sticky-header {
  position: sticky;
  top: 0;
  background: #212529;
  color: white;
}

.text-primary {
  color: #0056b3 !important;
}

.table-striped tbody tr:hover {
  background-color: rgba(0, 123, 255, 0.1);
  transition: background 0.2s ease-in-out;
}

.products {
  background-color: #f8f9fa;
}

.table {
  margin-top: 20px;
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 31, 63, 0.1); /* Accente navy pentru hover */
}

.table-dark {
  background-color: #001F3F;
  color: #ffffff;
}
.schedule .card {
  border-radius: 12px;
  transition: transform 0.3s ease;
}

.schedule .card:hover {
  transform: translateY(-5px);
}

.schedule .card i {
  font-size: 1.5rem;
}

</style>